/**
 * Sticky Header Fix
 * Ensures the sticky header functionality works properly
 */

(function () {
  "use strict";

  // Function to initialize sticky header
  function initStickyHeader() {
    const headerSection = document.querySelector(
      '.header-section[data-header-sticky="true"]'
    );

    if (!headerSection) {
      return;
    }

    // Add sticky-header class if not already present
    if (!headerSection.classList.contains("sticky-header")) {
      headerSection.classList.add("sticky-header");
    }

    // Ensure IntersectionObserver is supported
    if ("IntersectionObserver" in window) {
      // Create intersection observer to track when header is sticky
      const observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.intersectionRatio < 1) {
              // Header is sticky
              entry.target.classList.add("sticked");

              // Dispatch custom event
              const stickedEvent = new CustomEvent("headerSticked", {
                detail: entry.target,
              });
              document.dispatchEvent(stickedEvent);
            } else {
              // Header is not sticky
              entry.target.classList.remove("sticked");

              // Dispatch custom event
              const unstuckEvent = new CustomEvent("headerUnstuck", {
                detail: entry.target,
              });
              document.dispatchEvent(unstuckEvent);
            }
          });
        },
        {
          threshold: [1],
        }
      );

      // Observe the header section
      observer.observe(headerSection);
    } else {
      // Fallback for browsers without IntersectionObserver
      console.warn(
        "IntersectionObserver not supported, sticky header may not work optimally"
      );

      // Simple scroll-based fallback
      let isSticky = false;

      function handleScroll() {
        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop;
        const headerHeight = headerSection.offsetHeight;

        if (scrollTop > headerHeight && !isSticky) {
          isSticky = true;
          headerSection.classList.add("sticked");
        } else if (scrollTop <= headerHeight && isSticky) {
          isSticky = false;
          headerSection.classList.remove("sticked");
        }
      }

      window.addEventListener("scroll", handleScroll, { passive: true });
    }

    // Update CSS custom properties for header height
    function updateHeaderHeightVariables() {
      const mobileNavBar = document.querySelector(".mobile-nav-bar-wrapper");
      const siteHeader = document.querySelector(".site-header");

      if (mobileNavBar) {
        const mobileHeight = mobileNavBar.offsetHeight;
        document.documentElement.style.setProperty(
          "--header-height-mobile",
          mobileHeight + "px"
        );

        if (headerSection.dataset.headerSticky === "true") {
          document.documentElement.style.setProperty(
            "--sticky-header-mobile-height",
            mobileHeight + "px"
          );
        }
      }

      if (siteHeader) {
        const desktopHeight = siteHeader.offsetHeight;
        document.documentElement.style.setProperty(
          "--header-height-desktop",
          desktopHeight + "px"
        );

        if (headerSection.dataset.headerSticky === "true") {
          document.documentElement.style.setProperty(
            "--sticky-header-desktop-height",
            desktopHeight + "px"
          );
        }
      }
    }

    // Update height variables on load and resize
    updateHeaderHeightVariables();
    window.addEventListener("resize", updateHeaderHeightVariables);
    window.addEventListener("load", updateHeaderHeightVariables);

    // Handle overlay headers
    const overlayHeader = headerSection.querySelector(".overlay-header");
    if (overlayHeader) {
      // Listen for sticky events
      document.addEventListener("headerSticked", function () {
        overlayHeader.style.backgroundColor = "var(--header-color)";
      });

      document.addEventListener("headerUnstuck", function () {
        overlayHeader.style.backgroundColor = "transparent";
      });
    }

    console.log("Sticky header initialized successfully");
  }

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initStickyHeader);
  } else {
    initStickyHeader();
  }

  // Re-initialize if header is dynamically loaded (for theme editor)
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", function (event) {
      if (event.detail.sectionId && event.detail.sectionId.includes("header")) {
        setTimeout(initStickyHeader, 100);
      }
    });
  }
})();
